import React, { Component } from 'react';

import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { getQueryParam } from '../../../utils/queryParameters';
import { HttpCallStatus } from '../../../slices/auth/login.thunk.interfaces';
import { IRepdataSingleSignLoginWithCode, repdatatUserSingleSignOnLogin, fetchWhoAmI } from '../../../slices/auth/login.thunks';
import { RootState } from '../../../slices/rootReducer';
import { selectors } from '../../../slices/auth';
import Loader from '../../common/loader';

const { selectRepdataSSOLoginStatus, selectFetchWhoAmIStatus } = selectors;

interface IDispatchProps {
  repdatatUserSingleSignOnLogin: (request: IRepdataSingleSignLoginWithCode) => void;
  fetchWhoAmI: () => void;
}

interface IMapStateToProps {
  isLoggedIn: boolean;
  repdataSSOLoginStatus: HttpCallStatus;
  fetchWhoAmIStatus: HttpCallStatus;
}

enum ProcessingStatus {
  Processing = 'processing',
  Error = 'error',
  Success = 'success'
}

interface IState {
  status: ProcessingStatus;
  errorMessage: string | null;
  readyToRedirect: boolean;
}

type IProps = IDispatchProps & IMapStateToProps;

class RepdataSSOLoginHandlerBase extends Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      status: ProcessingStatus.Processing,
      errorMessage: null,
      readyToRedirect: false
    };
  }

  componentDidMount(): void {
    this.handleCallback();
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    const { repdataSSOLoginStatus, fetchWhoAmIStatus } = this.props;

    if(prevProps.repdataSSOLoginStatus === HttpCallStatus.Loading && repdataSSOLoginStatus === HttpCallStatus.Succeeded) {
      this.props.fetchWhoAmI();
    }
    if(prevProps.fetchWhoAmIStatus === HttpCallStatus.Loading && fetchWhoAmIStatus === HttpCallStatus.Succeeded) {
      this.setState({ readyToRedirect: true });
    }
  }

  getQueryParams() {
    const code = getQueryParam('code');
    const state = getQueryParam('state');
    const error = getQueryParam('error');
    const errorDescription = getQueryParam('error_description');

    return {
      code,
      state,
      error,
      errorDescription
    };
  }

  handleCallback = async () => {
    const { code, error, errorDescription } = this.getQueryParams();

    // WorkOS can redirect here with an error instead of a code
    // (e.g. user cancelled, or the IdP rejected the request).
    if (error) {
      this.setState({
        status: ProcessingStatus.Error,
        errorMessage: errorDescription || error
      });
      return;
    }

    if (!code) {
      this.setState({
        status: ProcessingStatus.Error,
        errorMessage: 'Missing authorization code in callback URL.'
      });
      return;
    }

    this.props.repdatatUserSingleSignOnLogin({ code });
  };

  render() {
    if(this.state.readyToRedirect) {
      return <Redirect to={'/accounts'} />;
    }
    return <div><Loader /></div>;
  }

}

const mapStateToProps = (state: RootState): IMapStateToProps => ({
  isLoggedIn: state.auth.isLoggedIn,
  repdataSSOLoginStatus: selectRepdataSSOLoginStatus(state),
  fetchWhoAmIStatus: selectFetchWhoAmIStatus(state)
});

const mapDispatchToProps: IDispatchProps = { repdatatUserSingleSignOnLogin, fetchWhoAmI };

export const RepdataSSOLoginHandler = connect(mapStateToProps, mapDispatchToProps)(RepdataSSOLoginHandlerBase);